import { createSlice } from '@reduxjs/toolkit';
import { query } from 'app/main/booking/graphql/status_graphql';
import axios from "axios";
import CONFIG from "app/config";

export const getBookingStatus =
    (refNum) => async (dispatch) => {
        const response = await axios.post(CONFIG.API + "/api/", {
            query: query.getBookingRefNum,
            variables: { refNum: refNum },
        });

        return response.data.data.bookingByRefNum;
    };

const initialState = {
    success: false,
    errors: [],
};

const registerSlice = createSlice({
    name: 'booking/register',
    initialState,
    reducers: {
        registerSuccess: (state, action) => {
            state.success = true;
            state.errors = [];
        },
        registerError: (state, action) => {
            state.success = false;
            state.errors = action.payload;
        },
    },
});

export const { registerSuccess, registerError } = registerSlice.actions;

export default registerSlice.reducer;